document.addEventListener('DOMContentLoaded', function() {
    // Show success message after form submission if there's a success query parameter
    if (window.location.search.includes('?contact_posted=true')) {
      document.getElementById('inquiryForm').querySelector('form').style.display = 'none';
      document.getElementById('inquirySuccessMessage').style.display = 'block';
      
      // Scroll to success message
      document.getElementById('inquirySuccessMessage').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    
    // Handle form submission
    const form = document.getElementById('inquiryForm').querySelector('form');
    form.addEventListener('submit', function() {
      sessionStorage.setItem('form_submitted', 'true');
    });
    
    // If form was submitted and we're back on the same page
    if (sessionStorage.getItem('form_submitted') === 'true' && window.location.search.includes('?contact_posted=true')) {
      document.getElementById('inquiryForm').querySelector('form').style.display = 'none';
      document.getElementById('inquirySuccessMessage').style.display = 'block';
      sessionStorage.removeItem('form_submitted');
    }
  });